import UnrecoverableErrorPage from './unrecoverable.error.page'

export default UnrecoverableErrorPage
